import React, {useRef, useEffect} from 'react';
import InputField from '../CreateFeed/Inputs/components/InputField';
import SourceButton from './SourceButton';
import SpinnerButton from 'components/SpinnerButton';
import useClickOutside from 'Helpers/useClickOutside';
import {DropdownToggle} from 'reactstrap';
import Tooltip from 'components/Tooltip';

const AddEntityHeader = (props) => {
    const headerInputRef = useRef(null);
    const {logoUrl, activeEntity, color, editingTitle, cancelEditingTitle,
        toggleEditingTitle, setEditingTitle, submitOrganizationChanges,
        saveEditedTitle, tempTitle, title, setTempTitle, activeSourceType,
        setActiveSourceType, submitting, preventActions} = props;

    useEffect(() => {
        setTempTitle(title)
    }, [editingTitle])

    useClickOutside(headerInputRef, () => {
        if(headerInputRef) {
            editingTitle && setEditingTitle(false);
        }
    });

    const handleActiveSourceSelect = (type) => {
        if(preventActions) return;
        setActiveSourceType(type)
    }

    return (
        <div className="add-entity-header">
            <div className="add-entity-header__logo-container">
                {logoUrl ?
                    <div
                        className="icon-with-letter"
                        style={{
                            background: `url(${logoUrl}) center center no-repeat`,
                            backgroundSize: 'contain',
                        }}
                    >
                    </div>
                    :
                    <div className="icon-with-letter" style={{ backgroundColor: color }}>
                        {activeEntity.feedName ? activeEntity.feedName[0] : activeEntity.title ? activeEntity.title[0] : ''}
                    </div>
                }
            </div>
            {editingTitle ?
                <div style={{ marginLeft: '15px', width: '100%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ alignSelf: 'flex-end' }}>Name</div>
                    </div>
                    <div className="d-flex w-100" ref={headerInputRef}>
                        <InputField
                            onSubmit={submitOrganizationChanges}
                            inputPlaceholder="Entity name"
                            showSubmitGlass={false}
                            parrentDataHandling={true}
                            value={tempTitle}
                            handleChange={setTempTitle}
                            highlightOnFocus
                        />
                        <SpinnerButton
                            className="ml-2"
                            title="Save"
                            onClick={submitOrganizationChanges}
                            submitting={submitting}
                            minWidth="91px"
                        />
                    </div>
                </div>
                :
                <div className="container_fullsize-centered" style={{ justifyContent: 'space-between' }}>
                    <div style={{ height: '100%', marginLeft: '15px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div>
                            <span style={{ fontSize: '1.1rem' }}>{title}</span>
                            <Tooltip placement="bottom" wide tooltip={`Rename`}>
                            <i
                                className="feedsActions ml-2 fas fa-pencil-alt"
                                onClick={toggleEditingTitle}
                            />
                            </Tooltip>
                        </div>
                        {activeEntity.domain &&
                        <div>{activeEntity.domain}</div>
                        }
                    </div>
                    <div>
                        <div style={{ marginLeft: '10px', position: 'relative', top: '-5px' }}>
                            <i style={{ color: '#FF8700'}} className="fas fa-plus-circle mr-1"/>
                            Add more sources to follow
                        </div>
                        <div style={{ display: 'flex' }}>
                            <SourceButton onSelect={() => handleActiveSourceSelect('twitter')} icon="fab fa-twitter" backgroundColor="#1DA1F2" name="Twitter"/>
                            <SourceButton onSelect={() => handleActiveSourceSelect('facebook')} icon="fab fa-facebook-f" backgroundColor="#4267B2" name="Facebook"/>
                            <SourceButton onSelect={() => handleActiveSourceSelect('youtube')} icon="fab fa-youtube" backgroundColor="#FF0000" name="YouTube"/>
                            <SourceButton onSelect={() => handleActiveSourceSelect('instagram')} icon="fab fa-instagram" name="Instagram"/>
                            <SourceButton onSelect={() => handleActiveSourceSelect('rss')} icon="fas fa-rss" backgroundColor="#ee802f" name="RSS"/>
                            <SourceButton
                                onSelect={() => handleActiveSourceSelect('google_ozmosys')}
                                icon="fas fa-globe" backgroundColor="#314784"
                                name="Google News"
                                disabled={(activeEntity.elements && activeEntity.elements.find(item => item.type === 'google_ozmosys'))}
                            />
                            <SourceButton onSelect={() => handleActiveSourceSelect('web')} icon="fas fa-cog" backgroundColor="#6E7179" name="Feed Builder"/>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default AddEntityHeader;
